// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__HaxYu","actions":"GroupTable_actions__AqypK","deleteModalFooter":"GroupTable_deleteModalFooter__bbDGu"};